import { useState, useEffect, useContext } from "react";
import { Card } from "antd";

import { Context } from "../../context";

import "./styles.css";

const Analytics = () => {
  const { apiUrl } = useContext(Context);
  const [src, setSrc] = useState("");
  useEffect(() => {
    if (apiUrl.includes("rl-api.fastpix.com")) {
    // if (true) {
      setSrc(
        "https://plausible.io/share/tv.rocketlane.com?auth=I9HT9mRQ-ei6ySAQNR-8H&embed=true&theme=light"
      );
    } else {
      setSrc(
        "https://ottmetrics.fastpix.dev/share/rltv.fastpix.io?auth=dPu72zAnOaXPqTDmbTiDl&embed=true&theme=light&background=transparent"
      );
    }
  }, [apiUrl]);

  return (
    <div>
      <Card title="Website Analytics" className="reports-wrapper">
        <iframe
          title="Plausible Analytics"
          src={src}
          loading="lazy"
          style={{
            width: "1px",
            minWidth: "100%",
            height: "100vh",
            border: "none",
            overflow: "auto",
          }}
        />
        <script
          async
          src="https://ottmetrics.fastpix.dev/js/embed.host.js"
        ></script>
      </Card>
    </div>
  );
};

export default Analytics;
